import axios from 'axios';
import endpoints from '@/api/endpoints';
import _ from 'lodash';

export default {
  async getOpenInquiries () {
    return axios.get(endpoints.inquiries + '?estimate_generated=false&archived=false').then((response) => {
      return _.orderBy(response.data, 'date_created')
    })
  },
  async getSoldAndArchivedInquiries () {
    return axios.get(endpoints.inquiries + '?estimate_generated=true').then((response) => {
      let ret = response.data
      return axios.get(endpoints.inquiries + '?archived=true').then((response) => {
        return _.concat(ret, response.data)
      })
    })
  },
  async getProgressedInquiries () {
    return axios.get(endpoints.inquiries + '?estimate_generated=true&archived=false').then((response) => {
      return _.orderBy(response.data, 'date_created')
    })
  },
  async createInquiry (obj) {
    return axios.post(endpoints.inquiries, obj).then((response) => {
      return response.data
    })
  },
  async getInquiry (id) {
    return axios.get(endpoints.inquiries + id + '/').then((response) => {
      return response.data
    })
  },
  async updateInquiry (obj) {
    return axios.patch(endpoints.inquiries + obj.id + '/', obj).then((response) => {
      return response.data
    })
  },
}
